import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import { Adapter, IFormStatAssess, JobService, KPIStatus, KPISummaryService, KpiSummaryDto, Pattern, SeasonDto, StatAssessDto, StatAssessRequestDto, StatService, } from '../../modules/core'
import { ResoveTimeZone, catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormDataPicker, FormInputNumber } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'
import { FormSelectMonth } from 'app/components/formInputs/FormSelectMonth'


type Props = {

}

let initValue: IFormStatAssess = {
    recordDate: ResoveTimeZone(new Date()),
    numberOfCase: 0,
    income: 0,
    workingHour: 0,
    numberOfVocation: 0,
    workingPercentage: 0,
    seasonId: 0,
    lastHr: 0,
    workingDay: 0
}

const formSchema = Yup.object().shape({
    recordDate: Yup.date().nullable().required('require'),
    numberOfCase: Yup.number().required('require'),
    income: Yup.number().required('require'),
    workingHour: Yup.number().required('require'),
    workingDay: Yup.number().required('require'),
    //lastHr: Yup.number().moreThan(0, "ไม่พบชั่วโมงทำงานของเดือนนี้").required("ไม่พบชั่วโมงทำงานของเดือนนี้")
    // workingPercentage: Yup.number().required('require'),
})



export const StatDetailPage: FC<Props> = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<IFormStatAssess>(initValue)
   
    const { id } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const init = async () => {
            
            if (id && id !== 'new') {
                const statRes = await StatService.GetById(parseInt(id));
               
                if (statRes) {                    
                    const model = Adapter.FormStatAssess(statRes.data.result)                    
                    //JavaScript's Date object tracks time in UTC internally, 
                    //https://stackoverflow.com/questions/15141762/how-to-initialize-a-javascript-date-to-a-particular-time-zone
                    const res = await JobService.GetLastHr(model.recordDate)
                    model.lastHr = res.data.result
              
                    setData(model);
                }
            } else {
                const res = await JobService.GetLastHr(ResoveTimeZone(new Date()))
                setData({
                    ...data,
                    recordDate:lastSeason.periodStart,
                    lastHr: res.data.result
                });
            }
            setLoading(false)
        }
        init()
    }, [id])

 

    const GetLastHr = async (date: Date, setFieldValue: any, setFieldTouched: any) => {
        setLoading(true)
        var res = await JobService.GetLastHr(date)
        setFieldValue('lastHr', res.data.result)
        setFieldTouched('lastHr')
        setLoading(false)
    }


    const calculate = (value: IFormStatAssess, setFieldValue: any) => {

        const numberOfCase = Number(value.numberOfCase);
        const workingHour = Number(value.workingHour);
        const workingDay = Number(value.workingDay);
        const lastHr = Number(value.lastHr);
        if ((workingHour - workingDay) <= 0) {
            setFieldValue('workingPercentage', 0)
            return;
        }

        const workingPercentage = Math.round(((numberOfCase + lastHr) / (workingHour - workingDay)) * 100);
        setFieldValue('workingPercentage', workingPercentage)

    }


    const onSubmit = async (values: IFormStatAssess) => {
        setLoading(true)

        if (!lastSeason?.id) {
            toast.error('season โหลดไม่ถูกต้อง')
            setLoading(false)
            return
        }

        const updatedData = Adapter.mapStatAsess(values)
        if (!updatedData) {
            toast.error('Unexpected error.')
            setLoading(false)
            return
        }

        updatedData.seasonId = lastSeason?.id
        if (id === 'new') {
            Save(updatedData)
        } else if (id) {
            Update(parseInt(id), updatedData)
        }

        
    }

    const Save = (updatedData: StatAssessRequestDto) => {
        StatService.Create(updatedData)
            .then((res) => {
                toast.success('Save Success.')
                navigate('/stat')
            }).catch((res) => {
                toast.error(catchErrorMsg(res))
                setLoading(false)
            })
    }

    const Update = (id: number, updatedData: StatAssessRequestDto) => {
        StatService.Update(id, updatedData).then(() => {
            toast.success('Update Success.')
            navigate('/stat')
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }

    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-4'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}



            </div>
        )
    }



    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'ประเมินตนเอง',
                        path: '/selfAssess',
                        isSeparator: false,
                        isActive: false,
                    },
                ]}
            >
                คะแนนพิเศษ
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}
                >
                    {
                        ({ values, handleSubmit, setFieldValue, setFieldTouched, errors, touched }) => (
                            <Form>
                                <>
                                    {/* begin::Scroll */}
                                    <div className='card-body p-9'>
                                        <CellStyle lable='เลือกเดือน'>
                                            <Field
                                                name={'recordDate'}
                                                startMonth={new Date(lastSeason.periodStart)}
                                                endMonth={new Date(lastSeason.periodEnd)}
                                                onSelectedChange={async (e: any) => {
                                                    await GetLastHr(new Date(e.target.value), setFieldValue, setFieldTouched)

                                                }}
                                               
                                                component={FormSelectMonth}
                                            />
                                            <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='จำนวนเคส' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='ราย'>
                                            <Field
                                                name='numberOfCase'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.numberOfCase && touched.numberOfCase ? ' is-invalid' : '')
                                                }
                                                maxLength={18}
                                                pattern={Pattern.Number2Digit}
                                                component={FormInputNumber}
                                                handleChange={(e: any) =>
                                                    calculate({
                                                        ...Object.assign({}, values),
                                                        numberOfCase: e.target?.value ?? 0
                                                    }, setFieldValue)
                                                }
                                                handleBlur={(e: any) => calculate({
                                                    ...Object.assign({}, values),
                                                    numberOfCase: e.target?.value ?? 0
                                                }, setFieldValue)}
                                            />
                                            <ErrorMessage name={`numberOfCase`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='รายได้' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='บาท'>
                                            <Field
                                                name='income'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.income && touched.income ? ' is-invalid' : '')
                                                }
                                                maxLength={18}
                                                pattern={Pattern.Number2Digit}
                                                component={FormInputNumber}
                                            />
                                            <ErrorMessage name={`income`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='ชม.ทำงาน' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='ชั่วโมง'>
                                            <Field
                                                name='workingHour'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.workingHour && touched.workingHour ? ' is-invalid' : '')
                                                }
                                                maxLength={18}
                                                pattern={Pattern.Number2Digit}
                                                component={FormInputNumber}
                                                handleChange={(e: any) => calculate({
                                                    ...Object.assign({}, values),
                                                    workingHour: e.target?.value ?? 0
                                                }, setFieldValue)}
                                                handleBlur={(e: any) => calculate({
                                                    ...Object.assign({}, values),
                                                    workingHour: e.target?.value ?? 0
                                                }, setFieldValue)}
                                            />
                                            <ErrorMessage name={`workingHour`} component='div' className='text-danger' />
                                        </CellStyle>
                                        <CellStyle lable='จำนวนวันที่มาทำงาน' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='วัน'>
                                            <Field
                                                name='workingDay'
                                                className={
                                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                    (errors.workingDay && touched.workingDay ? ' is-invalid' : '')
                                                }
                                                maxLength={18}
                                                pattern={Pattern.Number2Digit}
                                                component={FormInputNumber}
                                                handleChange={(e: any) => calculate({
                                                    ...Object.assign({}, values),
                                                    workingDay: e.target?.value ?? 0
                                                }, setFieldValue)}
                                                handleBlur={(e: any) => calculate({
                                                    ...Object.assign({}, values),
                                                    workingDay: e.target?.value ?? 0
                                                }, setFieldValue)}
                                            />
                                            <ErrorMessage name={`workingDay`} component='div' className='text-danger' />
                                        </CellStyle>

                                        <CellStyle lable='Job assignment' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='ชั่วโมง'>
                                            <label className='fs-1'>{values.lastHr}</label>
                                            <ErrorMessage name={`lastHr`} component='div' className='text-danger' />
                                        </CellStyle>

                                        <CellStyle lable='เปอร์เซ็นต์การทำงาน' inputCls='col-lg-2' txtEndCls='col-lg-2' textEnd='%'>
                                            <label className='fs-1'>{values.workingPercentage}</label>
                                        </CellStyle>

                                    </div>
                                    {/* end::Scroll */}

                                    <div className='card-footer d-flex py-6 px-9'>
                                        <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                            {!loading && 'Save Changes'}
                                            {loading && (
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            )}
                                        </button>

                                        <button className='btn btn-light' onClick={() => navigate('/stat')}> Back</button>
                                    </div>
                                </>
                            </Form>
                        )}
                </Formik>
            </div>
        </>
    )
}

